import React from 'react';
import PropTypes from 'prop-types';
import { countries } from 'country-data';

import _ from 'lodash';

import BlockLabel from './block-label';

const leftAlign = {
  textAlign: 'left',
};

const padding20 = {
  padding: 20,
  height: 150,
};

const Location = props => {
  const { profile } = props;
  const { locations } = _.get(profile, 'locations');

  if (!locations) {
    return (
      <div style={padding20}>
        <div>
          <h4 style={leftAlign}>
            <span>Location Data no available</span>
          </h4>
        </div>
        <BlockLabel label="Location" />
      </div>
    );
  }

  const validCountries = _.reject(_.get(locations, 'countryData'), loc => (loc.id === 'TBD' ));
  const totalLocations = locations.total;
  const countryData = _.take(_.orderBy(validCountries, 'count', 'desc'), 3);
  return (
    <div style={padding20}>
      {
        _.map(countryData, cd => {
          const country = _.find(countries.all, ['alpha2', cd.code || 'GB']);
          console.log(country);
          return (
            <div>
              <h4 style={leftAlign}>
                <div style={{ float: 'right' }}>{Math.round(cd.count / totalLocations * 100)}%</div>
                <span>{country.emoji} {cd.id}</span>
              </h4>
            </div>
          );
        })
      }

      <BlockLabel label="Location" />
    </div>
  );
};

Location.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default Location;



// WEBPACK FOOTER //
// ./src/containers/summary/components/location.js